<template>
  <div :class="['iframe-modal', { alpha: pageLoaded }]" v-if="showIframe">
    <div class="iframe-container" :style="containerSize"></div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Postmate from "postmate";
import { sleep } from "../../common/utils";

export default {
  name: "iframeModal",
  data() {
    return {
      isFunction: this.util.generatorCheckType("function"),
      handshake: null,
      timer: null,
      reloadTurns: 0,
    };
  },
  props: {
    w: {
      type: [Number, String],
      default: "100%",
    },
    h: {
      type: [Number, String],
      default: "100%",
    },
  },
  watch: {
    showIframe(newVal) {
      console.log(this.showIframe ? "开启iframe" : "关闭iframe");
    },
    efSound(newVal) {
      if (this.iframe) iframe.call("setMuted", !newVal);
    },
  },
  computed: {
    ...mapState("postmateIframe", [
      "showIframe",
      "pageLoaded",
      "iframe",
      "iframeStartLoadingTime",
    ]),
    ...mapState(["efSound"]),
    containerSize() {
      let isNumber = this.util.generatorCheckType("number");
      let width = isNumber(this.w) ? this.w + "px" : this.w,
        height = isNumber(this.h) ? this.h + "px" : this.h;
      return {
        width,
        height,
      };
    },
  },
  mounted() {
    this.$store.dispatch("postmateIframe/upDateIframeComponent", this);
  },
  methods: {
    openURL(url, onStart, onOver, loadingAppendTarget = null) {
      this.reloadTurns = 0;
      this.$Spinner.showLoading(loadingAppendTarget, true, true, true);
      this.$store.dispatch("postmateIframe/upDateShowIframe", true);
      this.$nextTick(async () => {
        await sleep(1000);
        this.loadIframe(url, onStart, onOver, loadingAppendTarget);
        this.timer = setInterval(() => {
          if (
            !this.pageLoaded &&
            Date.now() - this.iframeStartLoadingTime > 1000 * 20
          ) {
            this.$store.dispatch("postmateIframe/upDateStartTime");
            document
              .querySelector(".iframe-container .out-page_" + this.reloadTurns)
              .remove();
            this.reloadTurns++;
            if (this.reloadTurns > 3) {
              clearInterval(this.timer);
              this.timer = null;
              this.$Spinner.hideLoading(loadingAppendTarget);
              this.$store.dispatch("postmateIframe/reSetIframe");
              this.$toast(this.T("系统错误"));
              return;
            }
            this.$toast(this.T("reload({0})", this.reloadTurns));
            this.loadIframe(url, onStart, onOver, loadingAppendTarget);
          }
        }, 1000);
      });
    },
    loadIframe(url, onStart, onOver, loadingAppendTarget) {
      const _this = this;
      console.log("游戏地址：", url);
      try {
        console.log(this.reloadTurns);
        this.handshake = new Postmate({
          container: document.querySelector(".iframe-container"),
          url: url,
          name: "bigGame",
          classListArray: ["out-page_" + this.reloadTurns],
        });
        this.handshake.then((child) => {
          clearInterval(this.timer);
          this.timer = null;
          _this.$store.dispatch(
            "postmateIframe/upDateHandshake",
            _this.handshake
          );
          _this.$store.dispatch("postmateIframe/upDateIframe", child);
          child.on("CONNECTED", (data) => {
            // alert("握手成功");
            _this.$store.dispatch("postmateIframe/upDateIframeName", data);
            _this.$store.dispatch("postmateIframe/upDatePageLoaded", true);
            _this.$Spinner.hideLoading(loadingAppendTarget);
            _this.iframeMuted(child);
            if (_this.isFunction(onStart)) {
              onStart(child);
            }
            child.on("GAME_OVER", ({ score }) => {
              if (_this.isFunction(onOver)) {
                onOver(score);
              }
              // 清空当前链接iframe信息
              _this.$store.dispatch("postmateIframe/reSetIframe");
            });
          });
        });
      } catch (err) {
        console.log(err);
      }
    },
    iframeMuted(iframe) {
      // 控制声音是否播放
      iframe.call("setMuted", !this.efSound);
    },
  },
};
</script>

<style lang="scss" scoped>
.iframe-modal {
  @include bgImg("root/loading_bg.jpg");
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10000;
  opacity: 0;
  transition: opacity 0.3s;
  &.alpha {
    opacity: 1;
  }
}
.iframe-container {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  margin: auto;
  box-shadow: 1px 1px 10px #000;

  ::v-deep iframe[class^="out-page_"] {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    border: none;
  }
}
</style>